import { StringValues } from "../interfaces/undetermined";

export const CONSULTANCY: StringValues = {
  entities: "entities",
  country: "country",
  manager: "manager",
  operation: "ope",
  month: "month",
  year: "year",
  type: "type",
  risk: "risk",
};
